import { render } from "./Logo.vue?vue&type=template&id=31273cc5"
const script = {}

import exportComponent from "/var/www/vhost/KIRON/app/datos.kiron.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__